import { useRequests } from '../redux/reducer/requests';
import { goldAppleLink } from '../constants/copyright';
import { defaultStore, useTranslation } from '../translations';
/**
 * Хук для получения URL магазина Gold Apple из Redux store
 * Формирует URL на основе appInfoData.baseUrl
 * @returns {string} - URL вида https://goldapple.{store} или fallback
 */
export const useGoldenAppleUrl = () => {
  const { t } = useTranslation();
  const { appInfoData } = useRequests();

  const baseUrl = appInfoData?.baseUrl;

  if (!baseUrl) {
    // Fallback на дефолтный URL если baseUrl еще не загружен
    return t(goldAppleLink) || `https://goldapple.${defaultStore}`;
  }

  return baseUrl;
};
